import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SELF_PERFIL } from 'constants/codigosTransacciones'

import PerfilPage from './perfil'

export default function SelfPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SELF_PERFIL}`} component={PerfilPage} />
      </Switch>
    </Suspense>
  )
}
